import { useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import Verification from "./Verification";
import { toast } from "react-toastify";

const Landing = (props) => {
  const blockchain = useSelector((state) => state.blockchain);
  const {
    symbol,
    saleEnded,
    minted,
    maxSupply,
    displayCost,
    decreament,
    increament,
    mintAmount,
    setMaxMint,
    maxMint,
    connectWallet,
    mintNFT,
    mintingStatus,
    feedback,
  } = props.myFunctions;
  const [isVerified, setIsVerified] = useState(false);
  console.log(feedback);
  return (
    <Container>
      <Wrapper className="">
        {/* {feedback && toast(feedback)} */}
        <h2 className="display-6 fw-bolder text-center ">
          Beyond Ordinary Women NFTs
        </h2>
        <p>Total Supply: {maxSupply} NFTs</p>

        <div className="rm py-3">
          <div className=" row border border-2 rounded-3 d-flex justify-content-between  align-items-center py-2 ">
            <div className="col-4">
              <img
                src="./config/images/bg.gif"
                className="img-fluid rounded "
              />
            </div>
            <div className="col ">
              <div className=" h-100 text-right d-flex flex-column justify-content-evenly align-items-end">
                <p style={{ fontSize: "smaller" }} className="py-1">
                  Unit price
                </p>
                <p className="py-1">
                  {displayCost} {"ETH"}
                </p>
                <p style={{ fontSize: "smaller" }} className="text-right py-1">
                  {" "}
                  Mint Date May 17th 2022
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between border border-3 my-1 rounded bg-secondary p-1 ">
          <i>
            <button
              onClick={(e) => decreament(e)}
              className="px-1 bg-transparent text-white border-0 rounded m-1"
            >
              -
            </button>
            <button className="px-1 bg-transparent text-white border-0 rounded m-1">
              {mintAmount}
            </button>
            <button
              onClick={(e) => increament(e)}
              className="px-1 bg-transparent text-white border-0 rounded m-1"
            >
              +
            </button>
          </i>
          <button
            onClick={() => {
              setMaxMint();
            }}
            className="px-1 bg-transparent text-white border-0 rounded m-1"
          >
            {maxMint} MAX
          </button>
        </div>
        <div className="d-flex justify-content-between border-top border-bottom border-2 p-1 my-3">
          <i className="">Total</i>
          <i className="">
            {" "}
            {displayCost * mintAmount} {symbol}
          </i>
        </div>
        <button
          disabled={mintingStatus === "MINTING" || saleEnded}
          onClick={(e) => {
            blockchain.account === "" || blockchain.smartContract === null
              ? connectWallet(e)
              : mintNFT(e);
          }}
          className="btn w-100"
        >
          {blockchain.account === "" || blockchain.smartContract === null
            ? "CONNECT WALLET"
            : mintingStatus}
        </button>
        {/* <StyledButton
          onClick={(e) => {
            blockchain.account === "" || blockchain.smartContract === null
              ? connectWallet(e)
              : mintNFT(e);
          }}
        >
          CONNECT WALLET
        </StyledButton> */}
      </Wrapper>
    </Container>
  );
};

export default Landing;
export const Container = styled.div`
  /* height: 100vh; */
  min-height: 100vh;
  display: flex;
  background: linear-gradient(100deg, var(--grey-200), var(--grey-300));
  /* background-color: "#F1F5F8"; */
  align-items: center;
  letter-spacing: var(--letterSpacing);
`;
export const Wrapper = styled.div`
  padding: 8rem;
  margin: auto;
  max-width: 600px;
  width: 80%;
  border-radius: var(--borderRadius);
  padding: 0.5rem;
  background-color: var(--primary-800);

  opacity: 0.8;
  color: var(--primary-100);
`;
